import React from 'react';
import { sanitizeRichText, hasQrCode } from '../../../../helpers/rich_text';

import QRCode from 'react-qr-code';

const nodeToReact = (node, key) => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const tag = node.tagName.toLowerCase();

  if (tag === 'qr-code') {
    const value = node.getAttribute('value') || '';
    if (!value) return null;
    return (
      <span key={key} style={{ display: 'block', margin: '16px auto', width: 'fit-content' }}>
        <QRCode value={value} size={180} />
      </span>
    );
  }

  const children = Array.from(node.childNodes).map((child, index) => nodeToReact(child, `${key}-${index}`));

  const props = { key };
  if (tag === 'a') {
    props.href = node.getAttribute('href') || undefined;
    props.target = node.getAttribute('target') || undefined;
    props.rel = node.getAttribute('rel') || undefined;
  }
  if (tag === 'br') return <br key={key} />;

  return React.createElement(tag, props, children.length > 0 ? children : null);
};

/**
 * Renders builder-authored text that may contain the allowed rich markup
 * (bold/underline/emphasis, line breaks, paragraphs, lists, links, and
 * qr-code elements). The HTML is sanitized to the allowed tag set before it
 * reaches the DOM. Content with a qr-code element is converted to React
 * elements so the QR code renders as a real, scannable image.
 */
const RichText = ({ html, as: Component = 'span', className }) => {
  const sanitized = sanitizeRichText(html);

  if (hasQrCode(sanitized)) {
    const parsed = new DOMParser().parseFromString(sanitized, 'text/html');
    const children = Array.from(parsed.body.childNodes).map((node, index) => nodeToReact(node, `rich-${index}`));
    return <Component className={className}>{children}</Component>;
  }

  return <Component className={className} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default RichText;
